import { createAsyncThunk } from '@reduxjs/toolkit';
import { setError, setMessage } from '../../../redux/slice';

import * as api from '../api';

export const doGetCompanies = createAsyncThunk<any, { page: number; take: number }>(
  'companies/doGetCompanies',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.getCompanies(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doGetPartnerCompanies = createAsyncThunk('companies/doGetPartnerCompanies', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getPartnerCompanies(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetCompany = createAsyncThunk('companies/doGetCompany', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getCompany(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetPartnerCompany = createAsyncThunk('companies/doGetPartnerCompany', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getPartnerCompany(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateCompany = createAsyncThunk('companies/doCreateCompany', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.createCompany(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateCompany = createAsyncThunk('companies/doUpdateCompany', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.updateCompany(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return response;
    }
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
